// extracted by mini-css-extract-plugin
export var apiV2AddContract = "api-v2-add-contract_PEvQA_pezdA2AlBU7KkD";
export var apiV2AddContractError = "api-v2-add-contract__error_JCrXoOTfu3m2sLxS3SS3";
export var apiV2AddContractSingleDate = "api-v2-add-contract__single-date_aizl3xDWiuFIO7z9Jrp2";